export const defaultEpicHandler = Symbol('default');
export function epicFromHandlers(handlers) {
  return (arg) => (handlers[arg.action.type] || handlers[defaultEpicHandler])?.(arg);
}
